/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationCrossPlayHandlersEventRuleDTO interface.
 */
export function instanceOfFxIdApplicationCrossPlayHandlersEventRuleDTO(value) {
    if (!('Game' in value) || value['Game'] === undefined)
        return false;
    if (!('EventId' in value) || value['EventId'] === undefined)
        return false;
    if (!('Code' in value) || value['Code'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSON(json) {
    return FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Game': json['Game'],
        'EventId': json['EventId'],
        'Code': json['Code'],
        'Filter1': json['Filter1'] == null ? undefined : json['Filter1'],
        'Filter2': json['Filter2'] == null ? undefined : json['Filter2'],
        'Filter3': json['Filter3'] == null ? undefined : json['Filter3'],
    };
}
export function FxIdApplicationCrossPlayHandlersEventRuleDTOToJSON(json) {
    return FxIdApplicationCrossPlayHandlersEventRuleDTOToJSONTyped(json, false);
}
export function FxIdApplicationCrossPlayHandlersEventRuleDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Game': value['Game'],
        'EventId': value['EventId'],
        'Code': value['Code'],
        'Filter1': value['Filter1'],
        'Filter2': value['Filter2'],
        'Filter3': value['Filter3'],
    };
}
//# sourceMappingURL=FxIdApplicationCrossPlayHandlersEventRuleDTO.js.map